"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Dbg {
    constructor(existing, t, decor) {
        this.transactions = t.transactions !== undefined ? t.transactions : existing.transactions;
        this.methods = t.methods !== undefined ? t.methods : existing.methods;
        this.reads = t.reads !== undefined ? t.reads : existing.reads;
        this.writes = t.writes !== undefined ? t.writes : existing.writes;
        this.changes = t.changes !== undefined ? t.changes : existing.changes;
        this.subscriptions = t.subscriptions !== undefined ? t.subscriptions : existing.subscriptions;
        this.outdating = t.outdating !== undefined ? t.outdating : existing.outdating;
        this.gc = t.gc !== undefined ? t.gc : existing.gc;
        this.silent = t.silent !== undefined ? t.silent : existing.silent;
        this.color = decor ? decor.color : existing.color;
        this.prefix = decor ? decor.prefix : existing.prefix;
        this.margin = decor ? decor.margin : existing.margin;
    }
    static switch(trace, decor, enabled) {
        const existing = Dbg.trace;
        if (enabled)
            Dbg.trace = new Dbg(existing, trace || existing, decor);
        return existing;
    }
    static log(operation, marker, message, ms = 0, highlight = undefined) {
        const margin = "  ".repeat(Dbg.trace.margin);
        if (!Dbg.trace.silent) /* istanbul ignore next */
            console.log("\x1b[37m%s\x1b[0m \x1b[" + Dbg.trace.color +
                "m%s %s\x1b[0m \x1b[" + Dbg.trace.color + "m%s%s\x1b[0m \x1b[" + Dbg.trace.color + "m%s\x1b[0m%s", "#rt", Dbg.trace.prefix, operation, margin, marker, message, (highlight !== undefined ? `${highlight}` : ``) +
                (ms > 2 ? `    [ ${ms}ms ]` : ``));
    }
}
exports.Dbg = Dbg;
Dbg.trace = new Dbg({
    transactions: false,
    methods: false,
    reads: false,
    writes: false,
    changes: false,
    subscriptions: false,
    outdating: false,
    gc: false,
    silent: false,
    color: 37,
    prefix: "",
    margin: 0
}, {});
